function CommunityType() {
  return (
    <svg
      width="41"
      height="41"
      viewBox="0 0 41 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <desc>커뮤니티 알림</desc>
      <g clipPath="url(#clip0_982_135)">
        <path
          d="M20.5 40.5C31.5457 40.5 40.5 31.5457 40.5 20.5C40.5 9.4543 31.5457 0.5 20.5 0.5C9.4543 0.5 0.5 9.4543 0.5 20.5C0.5 31.5457 9.4543 40.5 20.5 40.5Z"
          fill="white"
          stroke="#EEEEEE"
        />
        <path
          d="M15.337 21.4528C15.442 21.3539 15.5808 21.2988 15.725 21.2988H16.205V22.4168H15.955C13.91 24.3428 13.055 25.0528 12.604 25.0528C11.879 25.0528 11.845 24.6008 12.004 23.7368C12.067 23.3848 12.185 22.9118 12.357 22.3148C11.7689 22.1309 11.2561 21.7617 10.8952 21.2622C10.5343 20.7628 10.3448 20.1599 10.355 19.5438V15.2668C10.3281 14.3311 10.6735 13.423 11.3154 12.7417C11.9573 12.0603 12.8433 11.6616 13.779 11.6328H20.455C21.1162 11.6446 21.7603 11.8455 22.311 12.2118C22.8074 12.5489 23.2111 13.0053 23.485 13.5391C23.759 14.0729 23.8945 14.667 23.879 15.2668V16.3758H22.755V15.2678C22.7824 14.6294 22.5558 14.0061 22.1247 13.5344C21.6937 13.0626 21.0933 12.7809 20.455 12.7508H13.78C13.1417 12.7809 12.5413 13.0626 12.1102 13.5344C11.6792 14.0061 11.4526 14.6294 11.48 15.2678V19.5438C11.4596 19.9867 11.6152 20.4198 11.9129 20.7484C12.2106 21.077 12.6262 21.2745 13.069 21.2978C13.1566 21.2972 13.2431 21.3172 13.3216 21.3561C13.4 21.3951 13.4682 21.4519 13.5207 21.5221C13.5731 21.5923 13.6084 21.6738 13.6235 21.76C13.6387 21.8463 13.6334 21.935 13.608 22.0188C13.444 22.5521 13.3166 23.0018 13.226 23.3678C13.734 22.9371 14.4363 22.2985 15.333 21.4518L15.337 21.4528Z"
          fill="#01A0FF"
          stroke="#01A0FF"
          strokeWidth="0.3"
        />
        <path
          d="M22.144 12.5317H12.144C11.5918 12.5317 11.144 12.9795 11.144 13.5317V20.5317C11.144 21.084 11.5918 21.5317 12.144 21.5317H22.144C22.6963 21.5317 23.144 21.084 23.144 20.5317V13.5317C23.144 12.9795 22.6963 12.5317 22.144 12.5317Z"
          fill="#01A0FF"
        />
        <path
          d="M12.7589 21.1537C12.7589 21.1537 12.0449 24.4537 13.1959 24.0097C14.3469 23.5657 17.3629 19.3657 17.3629 19.3657L12.7589 21.1537Z"
          fill="#01A0FF"
        />
        <path
          d="M26.123 19.1128H19.623C19.2088 19.1128 18.873 19.4486 18.873 19.8628C18.873 20.277 19.2088 20.6128 19.623 20.6128H26.123C26.5373 20.6128 26.873 20.277 26.873 19.8628C26.873 19.4486 26.5373 19.1128 26.123 19.1128Z"
          fill="white"
        />
        <path
          d="M24.123 21.9238H19.623C19.2088 21.9238 18.873 22.2596 18.873 22.6738C18.873 23.088 19.2088 23.4238 19.623 23.4238H24.123C24.5373 23.4238 24.873 23.088 24.873 22.6738C24.873 22.2596 24.5373 21.9238 24.123 21.9238Z"
          fill="white"
        />
        <path
          d="M27.3403 25.8208C27.3403 25.8208 27.9933 28.3658 26.9403 28.0208C25.8873 27.6758 23.1343 24.4438 23.1343 24.4438L27.3403 25.8208Z"
          fill="white"
        />
        <path
          d="M25.644 14.4658H19.644C16.8826 14.4658 14.644 16.7044 14.644 19.4658V22.4658C14.644 25.2272 16.8826 27.4658 19.644 27.4658H25.644C28.4055 27.4658 30.644 25.2272 30.644 22.4658V19.4658C30.644 16.7044 28.4055 14.4658 25.644 14.4658Z"
          fill="white"
        />
        <path
          d="M19.3878 26.6507C18.4316 26.6261 17.5243 26.2229 16.8652 25.5296C16.2061 24.8364 15.8491 23.9099 15.8728 22.9537V19.3377C15.8605 18.8639 15.9418 18.3924 16.1118 17.95C16.2818 17.5077 16.5374 17.1031 16.8638 16.7595C17.1902 16.4159 17.5811 16.14 18.0142 15.9475C18.4473 15.755 18.914 15.6498 19.3878 15.6377H26.4178C27.3745 15.6623 28.2823 16.0659 28.9415 16.7598C29.6007 17.4537 29.9572 18.381 29.9328 19.3377V23.7377C29.9431 24.3753 29.7421 24.9984 29.3612 25.5098C28.9802 26.0212 28.4407 26.3921 27.8268 26.5647C28.0118 27.1927 28.1388 27.6887 28.2068 28.0567C28.3588 28.8897 28.3228 29.3637 27.6618 29.3637C27.2338 29.3637 26.2938 28.5967 24.1808 26.6477H19.3878V26.6507ZM26.6878 26.2877C26.6614 26.2103 26.6534 26.1278 26.6646 26.0469C26.6757 25.9659 26.7057 25.8886 26.752 25.8213C26.7984 25.7539 26.8599 25.6983 26.9315 25.659C27.0032 25.6197 27.0831 25.5976 27.1648 25.5947C27.4025 25.5886 27.6368 25.5357 27.8541 25.4391C28.0714 25.3425 28.2676 25.204 28.4314 25.0316C28.5952 24.8591 28.7235 24.6561 28.8088 24.4341C28.8941 24.2121 28.9349 23.9755 28.9288 23.7377V19.3377C28.9457 18.6549 28.6908 17.9932 28.2202 17.4982C27.7495 17.0032 27.1016 16.7152 26.4188 16.6977H19.3888C19.0502 16.7057 18.7165 16.7804 18.4068 16.9175C18.0971 17.0545 17.8175 17.2512 17.5838 17.4964C17.3501 17.7416 17.1671 18.0304 17.0451 18.3463C16.9231 18.6622 16.8645 18.9991 16.8728 19.3377V22.9577C16.8564 23.6406 17.1116 24.302 17.5823 24.797C18.0531 25.2919 18.701 25.5799 19.3838 25.5977H24.3728C24.496 25.5981 24.6145 25.6448 24.7048 25.7287C25.5048 26.4687 26.3181 27.1907 27.1448 27.8947C27.0095 27.3527 26.8571 26.817 26.6878 26.2877Z"
          fill="#01A0FF"
          stroke="#01A0FF"
          strokeWidth="0.3"
        />
        <path
          d="M26.1436 16.4658H19.1436C17.4867 16.4658 16.1436 17.809 16.1436 19.4658V23.4658C16.1436 25.1227 17.4867 26.4658 19.1436 26.4658H26.1436C27.8004 26.4658 29.1436 25.1227 29.1436 23.4658V19.4658C29.1436 17.809 27.8004 16.4658 26.1436 16.4658Z"
          fill="#01A0FF"
        />
        <path
          d="M26.1226 19.1875H19.6226C19.2083 19.1875 18.8726 19.5233 18.8726 19.9375C18.8726 20.3517 19.2083 20.6875 19.6226 20.6875H26.1226C26.5368 20.6875 26.8726 20.3517 26.8726 19.9375C26.8726 19.5233 26.5368 19.1875 26.1226 19.1875Z"
          fill="white"
        />
        <path
          d="M24.1226 21.9238H19.6226C19.2083 21.9238 18.8726 22.2596 18.8726 22.6738C18.8726 23.088 19.2083 23.4238 19.6226 23.4238H24.1226C24.5368 23.4238 24.8726 23.088 24.8726 22.6738C24.8726 22.2596 24.5368 21.9238 24.1226 21.9238Z"
          fill="white"
        />
        <path
          d="M27.3398 25.8208C27.3398 25.8208 27.9928 28.3658 26.9398 28.0208C25.8868 27.6758 23.1338 24.4438 23.1338 24.4438L27.3398 25.8208Z"
          fill="#01A0FF"
        />
      </g>
      <defs>
        <clipPath id="clip0_982_135">
          <rect width="41" height="41" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default CommunityType
